export enum EnumShape {
    RECTANGLE = 'RECTANGLE',
    CIRCLE = 'CIRCLE',
    SEMICIRCLE = 'SEMICIRCLE'
}

